module.exports = __webpack_public_path__ + "static/media/windows-media-audio.bfb3b141.svg";